// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_11697","item":"_8411","icon":"_14827","label":"_13010","active":"_9002"};